import { render, staticRenderFns } from "./upload_file_remark.vue?vue&type=template&id=0d5fe366"
import script from "./upload_file_remark.vue?vue&type=script&lang=js"
export * from "./upload_file_remark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports